export default "__VITE_ASSET__4c641d91__"